import { j as t } from "./jsx-runtime-DywqP_6a.js";
import { LogOutIcon as n } from "lucide-react";
import { S as i, a, b as u } from "./SignUp-C-YP_Rxi.js";
import { Z as m } from "./invariant-Bm-FVUQE.js";
class h {
  getRoutes() {
    return [
      {
        path: "/signout",
        element: /* @__PURE__ */ t.jsx(i, {})
      },
      {
        path: "/signin",
        element: /* @__PURE__ */ t.jsx(a, {})
      },
      {
        path: "/signup",
        element: /* @__PURE__ */ t.jsx(u, {})
      }
    ];
  }
  getProfileMenuItems() {
    return [
      {
        label: "Logout",
        path: "/signout",
        category: "bottom",
        icon: n
      }
    ];
  }
}
class x extends Error {
}
class f extends m {
  constructor(o, s, e) {
    super(o, e), this.error = s;
  }
}
export {
  x as A,
  h as C,
  f as O
};
//# sourceMappingURL=errors-ouIp07AW.js.map
